// Shared utility functions for Haiku API integration
// Can be used both client-side and server-side
export const HENLO_TOKEN_ADDRESS = "0xb2F776e9c1C926C4b2e54182FAc058dA9Af0B6A5";
export const BERACHAIN_CHAIN_ID = 80094; // Berachain mainnet

// Convert token address to Haiku IID format
export function toHaikuIID(chainId: number, tokenAddress: string): string {
  // Map chain IDs to Haiku chain slugs (from their docs)
  const chainSlugs: Record<number, string> = {
    1: "eth",
    42161: "arb",
    8453: "base",
    80094: "bera", // Fixed: should be "bera" not "berachain"
    56: "bsc",
    137: "poly", // Fixed: should be "poly" not "polygon"
    10: "opt", // Fixed: should be "opt" not "optimism"
    43114: "avax", // Fixed: should be "avax" not "avalanche"
    146: "sonic",
    999: "hype", // Fixed: should be "hype" not "hyperevm"
    130: "uni", // Fixed: should be "uni" not "unichain"
    1329: "sei",
    100: "gnosis",
    534352: "scroll",
    747474: "katana",
    33139: "ape", // Fixed: should be "ape" not "apechain"
    480: "worldchain",
  };

  const slug = chainSlugs[chainId] || chainId.toString();
  // Native tokens use 0xeeee... address in Haiku
  const address =
    tokenAddress.toLowerCase() === "0x0000000000000000000000000000000000000000"
      ? "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee"
      : tokenAddress.toLowerCase();

  return `${slug}:${address}`;
}

// Convert Haiku IID back to chain ID and address
export function fromHaikuIID(iid: string): { chainId: number; address: string } {
  const [chainSlug, address] = iid.split(":");

  const slugToChainId: Record<string, number> = {
    eth: 1,
    arb: 42161,
    base: 8453,
    bera: 80094, // Fixed: should be "bera" not "berachain"
    bsc: 56,
    poly: 137, // Fixed: should be "poly" not "polygon"
    opt: 10, // Fixed: should be "opt" not "optimism"
    avax: 43114, // Fixed: should be "avax" not "avalanche"
    sonic: 146,
    hype: 999, // Fixed: should be "hype" not "hyperevm"
    uni: 130, // Fixed: should be "uni" not "unichain"
    sei: 1329,
    gnosis: 100,
    scroll: 534352,
    katana: 747474,
    ape: 33139, // Fixed: should be "ape" not "apechain"
    worldchain: 480,
  };

  const chainId = slugToChainId[chainSlug] || Number(chainSlug);
  return { chainId, address };
}

// Helper to determine if a token is native on the given chain
export function isNativeTokenOnChain(chainId: number, tokenAddress: string): boolean {
  const nativeAddresses = [
    "0x0000000000000000000000000000000000000000",
    "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
  ];
  const address = tokenAddress.toLowerCase();
  return (
    nativeAddresses.includes(address) ||
    (chainId === BERACHAIN_CHAIN_ID && address === "0x0000000000000000000000000000000000000000")
  );
}
